











































import Vue from "vue";
import { mdiClose } from "@mdi/js";

export default Vue.extend({
    props: {
        currentDevice: {
            type: Object,
            required: true,
        },
        devices: {
            type: Array,
            required: true,
        },
    },
    data() {
        return { userDevice: this.currentDevice, mdiClose };
    },
    methods: {
        closeDialog(): void {
            this.$emit("close");
        },
        setDevice(): void {
            this.$emit("setDevice", this.userDevice);
        },
    },
});
